// extracted by mini-css-extract-plugin
export var chevron = "_r1-1";
export var clickable = "_r1-0";
export var ruleRow = "_r1-2";